const parseMoney = (value) => Number(String(value || "").replace(/\D/g, "")) || 0;
const fmt = (n) => new Intl.NumberFormat("vi-VN").format(parseMoney(n));

const splitDate = (dateText = "") => {
  const [day = "", month = "", year = ""] = String(dateText).split("/");
  return { day, month, year };
};

export const getPrintTemplate = ({ headerInfo, rows, totalAmount }) => {
  const { day, month, year } = splitDate(headerInfo.voucherDate);
  const rowsHtml = (rows || [])
    .map(
      (row) => `
      <tr>
        <td class="text-left">${row.description || ""}</td>
        <td class="text-center">${row.debitAccount || ""}</td>
        <td class="text-center">${row.creditAccount || ""}</td>
        <td class="text-right">${fmt(row.amount)}</td>
        <td class="text-left">${row.note || ""}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <title>Chứng Từ Ghi Sổ</title>
      <style>
        @media print {
          @page { margin: 10mm; size: portrait; }
        }
        body {
          font-family: "Times New Roman", Times, serif;
          color: #000;
          padding: 14px;
          font-size: 13px;
        }
        .header-top { display: flex; justify-content: space-between; margin-bottom: 14px; }
        .title-box { text-align: center; margin: 14px 0; }
        .title-main { font-size: 20px; font-weight: bold; margin: 0; text-transform: uppercase; }
        table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 12px; }
        th, td { border: 1px solid #000; padding: 4px; }
        th { text-align: center; font-weight: bold; vertical-align: middle; }
        .text-center { text-align: center; }
        .text-left { text-align: left; }
        .text-right { text-align: right; }
        .footer { margin-top: 26px; display: flex; justify-content: space-between; text-align: center; align-items: flex-start; }
        .sign-col { width: 30%; }
        .sign-date-row { min-height: 20px; margin-bottom: 2px; }
        .sign-title { font-weight: bold; }
        .sign-sub { font-style: italic; }
        .page-number {
          position: fixed;
          right: 8mm;
          bottom: 6mm;
          font-size: 11px;
        }
      </style>
    </head>
    <body>
      <div class="header-top">
        <div style="width: 60%;">
          <div><b>Đơn vị:</b> ${headerInfo.unit || ""}</div>
          <div style="margin-top: 6px;"><b>Địa chỉ:</b> ${headerInfo.companyAddress || ""}</div>
        </div>
        <div style="text-align: center; width: 40%;">
          <div style="font-weight: bold;">Mẫu số S02a-DN</div>
          <div style="font-style: italic; font-size: 12px;">
            (Kèm theo Thông tư số 99/2025/TT-BTC ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
          </div>
        </div>
      </div>

      <div class="title-box">
        <h2 class="title-main">CHỨNG TỪ GHI SỔ</h2>
        <div style="font-size: 14px; font-weight: bold; margin-top: 3px;">Số: ${headerInfo.voucherNumber || ""}</div>
        <div style="font-style: italic; margin-top: 6px;">Ngày ${day || "...."} tháng ${month || "...."} năm ${year || "...."}</div>
      </div>

      <table>
        <thead>
          <tr>
            <th rowspan="2">Trích yếu</th>
            <th colspan="2">Số hiệu tài khoản</th>
            <th rowspan="2">Số tiền</th>
            <th rowspan="2">Ghi chú</th>
          </tr>
          <tr>
            <th>Nợ</th>
            <th>Có</th>
          </tr>
          <tr>
            <th>A</th>
            <th>B</th>
            <th>C</th>
            <th>1</th>
            <th>D</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td class="text-center"><b>Cộng</b></td>
            <td class="text-center"><b>x</b></td>
            <td class="text-center"><b>x</b></td>
            <td class="text-right"><b>${fmt(totalAmount)}</b></td>
            <td class="text-center"><b>x</b></td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 12px;">
        Kèm theo ${headerInfo.attachmentsCount || ""} chứng từ gốc
      </div>

      <div class="footer">
        <div class="sign-col">
          <div class="sign-date-row">&nbsp;</div>
          <div class="sign-title">Người ghi sổ</div>
          <div class="sign-sub">(Ký, họ tên)</div>
        </div>
        <div class="sign-col">
          <div class="sign-date-row">&nbsp;</div>
          <div class="sign-title">Kế toán trưởng</div>
          <div class="sign-sub">(Ký, họ tên)</div>
        </div>
        <div class="sign-col">
          <div class="sign-date-row sign-sub">Ngày..... tháng..... năm.....</div>
          <div class="sign-title">Người đại diện theo pháp luật</div>
          <div class="sign-sub">(Ký, họ tên, đóng dấu)</div>
        </div>
      </div>

      <script>
        window.onload = function() { window.print(); };
      </script>
      <div class="page-number">1/1</div>
    </body>
  </html>
  `;
};
